// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {applySearchFilters} from './facets';
import {getPipSearchResults} from '../../shared/repositories';
import {readExcelLayouts} from '../../../shared/action-creators/read-excel-layouts';
import {routerActions} from 'react-router-redux';

export const updatePipSearchResults = (query, searchBy) =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const searchResults = await getPipSearchResults(query, searchBy);

            dispatch({
                searchByType: 'PIP',
                type: actions.UPDATE_PIP_SEARCH_BY_TYPE
            });

            dispatch({
                data: searchResults,
                type: actions.UPDATE_PIP_SEARCH_RESULTS_SUCCESS
            });

            dispatch({
                data: searchResults,
                type: actions.FILTER_PIP_SEARCH_RESULTS
            });

            dispatch({
                hasSearchResults: true,
                type: actions.UPDATE_PIP_HAS_SEARCH_RESULTS
            });

            dispatch(routerActions.push(`/pips/search?by=${searchBy}&q=${encodeURIComponent(query)}`));

            if (getState().pips.pipSearch.facets.pipTypesFacet.allowedTypes.length > 0) {

                applySearchFilters(getState().pips.pipSearch)(dispatch);

            }

            if (!getState().exportToExcel.selectedExcelLayout.pipSearch.name) {

                readExcelLayouts('pipSearch')(dispatch);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/pip/pip-search/action-creators/pip-search.js